"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgBellRingingOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.bell-ringing_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "bell-ringing_outline_svg__transparent_box" },
            React.createElement("path", { className: "bell-ringing_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "bell-ringing_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "bell-ringing_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M20.44 15.3v-.5c0-3-1.67-4.8-4.46-4.8s-4.46 1.84-4.46 4.8v.5a2.23 2.23 0 01-.8 1.93l-.74.4V21h3a4 4 0 00.37 1.46A2.78 2.78 0 0016 24a2.77 2.77 0 002.61-1.54A4 4 0 0019 21h3v-3.37l-.74-.4a2.15 2.15 0 01-.82-1.93zm-3.65 6.29c-.06.12-.2.41-.81.41s-.75-.29-.81-.41A1.83 1.83 0 0115 21h2a1.75 1.75 0 01-.21.59zM20 19h-8v-.21a4.23 4.23 0 001.54-3.49v-.5c0-1.86.82-2.8 2.46-2.8 1.05 0 2.46.29 2.46 2.8v.5A4.2 4.2 0 0020 18.8zM5.87 7.9L4.44 6.48a14.94 14.94 0 000 19.1l1.43-1.42a12.92 12.92 0 010-16.26z" }),
            React.createElement("path", { d: "M6.4 10.63a10.92 10.92 0 000 10.77L8 20.11a9 9 0 010-8.19zM27.51 6.48L26.09 7.9a12.93 12.93 0 010 16.26l1.43 1.42a14.94 14.94 0 000-19.1z" }),
            React.createElement("path", { d: "M25.56 10.63L24 11.92a9 9 0 010 8.19l1.58 1.29a11 11 0 000-10.77z" }))));
}
exports.default = SvgBellRingingOutline;
//# sourceMappingURL=BellRingingOutline.js.map